import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import productService from '../../services/productService';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';

const SearchResults = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q');
  
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const searchProducts = async () => {
      if (!query) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await productService.searchProducts(query);
        if (response.success) {
          setProducts(response.products);
        } else {
          setError('Search failed');
        }
      } catch (err) {
        setError('Error searching products');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    searchProducts();
  }, [query]);

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <div className="flex justify-center items-center min-h-[60vh] flex-grow">
          <div className="text-xl">Searching...</div>
        </div>
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <div className="flex justify-center items-center min-h-[60vh] flex-grow">
          <div className="text-red-600 text-xl">{error}</div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <div className="container mx-auto px-4 py-8 flex-grow">
        <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold mb-6">Search Results for "{query}"</h1>
        {products.length === 0 ? (
          <p className="text-gray-500">No products found matching your search.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {products.map((product) => (
              <div key={product._id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition">
                <Link to={`/product/${product._id}`}>
                  <img
                    className="w-full h-64 object-cover"
                    src={product.images && product.images[0] ? product.images[0].path : '/images/placeholder.jpg'}
                    alt={product.productTitle}
                  />
                  <div className="p-4">
                    <h4 className="font-semibold">{product.productTitle}</h4>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SearchResults;
